import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_calendar: SvgIconData = {
  viewBox: '0 0 20 20',
  element: (
    <path
      d="M6 5V1M14 5V1M5 9H15M3 19H17C18.1046 19 19 18.1046 19 17V5C19 3.89543 18.1046 3 17 3H3C1.89543 3 1 3.89543 1 5V17C1 18.1046 1.89543 19 3 19Z"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
